
import { ReactNode, useState } from 'react';

interface HologramCardProps {
  children: ReactNode;
  className?: string;
  glowColor?: string;
  onClick?: () => void;
  isActive?: boolean;
}

export default function HologramCard({ 
  children, 
  className = '', 
  glowColor = 'cyan', 
  onClick,
  isActive = false 
}: HologramCardProps) {
  const [isHovered, setIsHovered] = useState(false);

  const glowColors = {
    cyan: 'shadow-cyan-500/50 border-cyan-500/30 hover:shadow-cyan-500/80 hover:border-cyan-500/60',
    purple: 'shadow-purple-500/50 border-purple-500/30 hover:shadow-purple-500/80 hover:border-purple-500/60',
    green: 'shadow-green-500/50 border-green-500/30 hover:shadow-green-500/80 hover:border-green-500/60',
    orange: 'shadow-orange-500/50 border-orange-500/30 hover:shadow-orange-500/80 hover:border-orange-500/60',
    red: 'shadow-red-500/50 border-red-500/30 hover:shadow-red-500/80 hover:border-red-500/60',
    blue: 'shadow-blue-500/50 border-blue-500/30 hover:shadow-blue-500/80 hover:border-blue-500/60'
  };

  return (
    <div
      className={`
        relative bg-black/20 backdrop-blur-sm border-2 rounded-lg
        shadow-2xl transition-all duration-300 cursor-pointer
        ${glowColors[glowColor as keyof typeof glowColors]}
        ${isActive ? 'scale-105' : ''}
        ${isHovered ? 'transform -translate-y-2' : ''}
        ${className}
      `}
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
      onClick={onClick}
    >
      {/* Hologram scan lines */}
      <div className="absolute inset-0 bg-gradient-to-b from-transparent via-cyan-500/5 to-transparent animate-pulse rounded-lg"></div>
      
      {/* Content */}
      <div className="relative z-10 p-6">
        {children}
      </div>
      
      {/* Corner accents */}
      <div className="absolute top-2 left-2 w-4 h-4 border-l-2 border-t-2 border-cyan-400/60"></div>
      <div className="absolute top-2 right-2 w-4 h-4 border-r-2 border-t-2 border-cyan-400/60"></div>
      <div className="absolute bottom-2 left-2 w-4 h-4 border-l-2 border-b-2 border-cyan-400/60"></div>
      <div className="absolute bottom-2 right-2 w-4 h-4 border-r-2 border-b-2 border-cyan-400/60"></div>
    </div>
  );
}
